export const groupReliefGuideSteps = [
  {
    label: "Case setup",
    title: "Define the settings for the whole case",
    guidelines: [
      {
        label: "Year of Assessment (YA) and common financial year end (FYE)",
        text: "Choose the YA and FYE shared by the participating companies. Company selection uses these settings to find matching saved Tax Computations. The FYE must fall in the calendar year before the YA.",
      },
      {
        label: "Basis period",
        text: "The case uses a twelve-month basis period ending on the selected FYE. Its dates and calendar days are calculated automatically. When checking companies, check each company's own accounting period and continuous qualifying period, including Cross-YA computations.",
      },
      {
        label: "CIT rebate and cap",
        text: "Enter the rebate percentage and cap in SGD for this case. Both start at zero. These settings are used when comparing tax before and after Group Relief; check them before optimising.",
      },
      {
        label: "One case throughout the workflow",
        text: "A case brings together companies for one Group Relief calculation. Open Case & guide beside the page title to view your settings at any time. Choose Edit case setup to change them. Afterwards, check company selection and check the affected company details again.",
      },
    ],
    reminder:
      "This is a working case kept while the page is open. Leaving or refreshing the page clears it.",
  },
  {
    label: "Select companies",
    title: "Choose companies matching this case",
    guidelines: [
      {
        label: "Select at least two companies",
        text: "Choose participating companies with saved Tax Computations matching the case YA and FYE. If multiple computations match, select the one to use.",
      },
      {
        label: "Resolve unavailable companies",
        text: "Check the reason shown beside an unavailable company. Review the case settings or choose another eligible company before continuing to Company Details.",
      },
    ],
  },
  {
    label: "Check companies",
    title: "Check companies and calculate",
    guidelines: [
      {
        label: "Check the saved computation",
        text: "Compare the loaded figures with the company's Main Tax Computation. Check the company type, tax period and amounts before ticking the figures check.",
      },
      {
        label: "Confirm the qualifying period",
        text: "Confirm whether the qualifying relationship was maintained throughout the basis period. Complete the continuous qualifying period where required.",
      },
      {
        label: "Continue company by company",
        text: "Answer the shareholding question and tick the figures check. A company becomes Ready automatically when the required details are complete. Choose a company in the list; when all are Ready, select Review & calculate to open the review dialog.",
      },
      {
        label: "Review before calculating",
        text: "In the review dialog, check the case settings and computations, confirm Group Relief eligibility, then select Calculate Group Relief. Close the dialog or choose Back to companies to return to your details. Results appear after calculation.",
      },
      {
        label: "Inspect the results",
        text: "Review Detailed Computation Output, Recommended Transfers and Company Results to see the transfer amounts and tax before and after Group Relief.",
      },
      {
        label: "Generate GR-A and GR-B",
        text: "Download the populated forms from the results. Check company particulars, transfer priority, amounts and qualifying periods, and complete the declarations and signatures before submission.",
      },
    ],
  },
];
